// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"aee1dd8c","66":"8c918e55","145":"7b0e737e","190":"ba8a838a","613":"4020565a","906":"c18de511","948":"c492ef5e","957":"b6eb8cd0","969":"97fdda20"}[chunkId] + ".chunk.js";
};